import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import {types as CardType} from "credit-card-type";
import MetsIcon from 'commons/components/MetsIcon';

function PaymentModeToggle({creditCardToggleAction, existingCardLabel, existingCCType, isPayingWithNewCreditCard, ccType, newCardLabel}) {

    /**
     * Generates the display next to the label that shows the icon for the existing CC on file.
     */
    function getExistingCreditCardDisplay() {
        return (
            <>
                {existingCCType == "VISA" && <MetsIcon data-testid="svgExistingCCVisa" name="svg_VISA" className={isPayingWithNewCreditCard ? '' : 'colorVISA'} key="VISA" />}
                {existingCCType == "MC" && (!isPayingWithNewCreditCard ? <MetsIcon data-testid="svgExistingCCMC" name="svg_color_MC" className="colorMC" key="color_MC" /> : <MetsIcon data-testid="svgExistingCCMC" name="svg_MC" key="MC" />)}
                {existingCCType == "AMEX" && <MetsIcon data-testid="svgExistingCCAE" name="svg_AE" className={isPayingWithNewCreditCard ? '' : 'colorAE'} key="AE" />}
            </>
        );
    }

    function getCurrentCreditCardDisplay() {
        return (
           <>
               <MetsIcon data-testid="svgNewCCVisa" name="svg_VISA" className={(ccType == CardType.VISA || !ccType) && isPayingWithNewCreditCard ? 'colorVISA' : ''} key="VISA" />
               {(ccType == CardType.MASTERCARD || !ccType) && isPayingWithNewCreditCard ? <MetsIcon data-testid="svgNewCCMC" name="svg_color_MC" className="colorMC" key="color_MC" /> : <MetsIcon data-testid="svgNewCCMC" name="svg_MC" key="MC" />}
               <MetsIcon data-testid="svgNewCCAE" name="svg_AE" className={(ccType == CardType.AMERICAN_EXPRESS || !ccType) && isPayingWithNewCreditCard ? 'colorAE': ''} key="AE" />
           </>
       );
   }

    return <>

        <Field name="payWithNewCard" as="input" type="hidden" />

        <div data-testid="existingCardOption" className={`payment-toggle-section ${isPayingWithNewCreditCard ? '' : ' selected'}`}
            onClick={() => {creditCardToggleAction(false)}}>
            <span className="radio-look"></span>
            <p>{existingCardLabel}</p>
            {getExistingCreditCardDisplay()}
        </div>

        <div data-testid="useNewCard" className={`payment-toggle-section ${isPayingWithNewCreditCard ? ' selected' : ''}`}
            onClick={() => {creditCardToggleAction(true)}}>
            <span className="radio-look"></span>
            <p>{newCardLabel}</p>
            {getCurrentCreditCardDisplay()}
        </div>
    </>
}

PaymentModeToggle.propTypes = {
    /** Action triggered when you change which mode is selected */
    creditCardToggleAction: PropTypes.func,
    /** State being given from above that tells you the current value */
    isPayingWithNewCreditCard: PropTypes.bool,
    /** Label provided for the Use Existing Card option */
    existingCardLabel : PropTypes.string,
    /** Used to determine which icon to display next to the existing card label */
    existingCCType : PropTypes.string,
    /** Label shown next to the Pay with New Card Option*/
    newCardLabel: PropTypes.string,
    /** Displays the available options next to new credit card label. Can be used to show the supported credit card options. */
    ccType: PropTypes.string,
    /** Function called when you click on the divs to switch the CreditCard Payment Mode between Use Existing/Pay With New */
    toggleCreditCardPaymentMode: PropTypes.func
};

export default PaymentModeToggle;